import { useChatbotRegistration } from '@/common/ai/ChatbotMgrContext';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useEntityFromRoute } from '@/common/hooks/route/useEntityFromRoute';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { usePrincipal } from '@/common/principal/PrincipalContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Mode } from '../entityFramework/enumerations/Mode';
import { useNavState } from '../navState/NavStateContext';
import { TitleButton } from './TitleButton';

export const ValButton = ({ selectedEntityIds, disabledReason: disabledReasonProp }) => {
  const { entityObj, entityDef, hist, asOfDate } = useEntityMgr();
  const { mode } = useNavState();

  const rsrc = useRsrc();
  const module = useModuleFromRoute();
  const entity = useEntityFromRoute();

  // Only render if the use has appropriate Role
  const { hasRole } = usePrincipal();
  const shouldRender = hasRole(`${module.toUpperCase()}_${entity}_SAVE`);

  let disabledReason = disabledReasonProp;
  if (!disabledReasonProp) {
    if (mode === Mode.DETAIL) {
      // Detail Scenario
      disabledReason = hist || asOfDate ? 'viewing historical data' : null;
    } else if (selectedEntityIds?.length === 0) {
      // List scenario
      disabledReason = 'no records are selected';
    }
  }

  useChatbotRegistration(
    'Validate button',
    shouldRender &&
      `Runs a validation job on the selected ${entityDef?.displayName ?? entity} record(s) and ` +
        `their children, checking business rules before approval. ` +
        (disabledReason != null ? `Currently disabled because ${disabledReason}.` : 'Currently enabled.'),
  );

  if (!shouldRender) return;

  const validate = () => {
    const reqParam = {
      ids: selectedEntityIds ?? [entityObj.id],
      entity: entity,
    };
    const job = {
      name: 'Validation',
      code: 'VAL_' + entity,
      module: module,
      rsrcCode: 'DEFAULT_VAL_ACTION_PLUGIN',
      entity: entity,
      entityId: entityObj?.id,
      reqParamJson: JSON.stringify(reqParam),
      cat: 'ACTION',
    };

    rsrc.save('skdr', 'JOB', job).then((job) => {
      rsrc.start(job.id);
    });
  };

  return (
    <TitleButton
      dataTestId={'val-button'}
      icon={fas.faShieldCheck}
      toolTip="Validate"
      disabled={disabledReason != null}
      onClick={validate}
    />
  );
};
